"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseILeadFeedbackSettingsEvents = void 0;
const ilead_feedback_stage_settings_1 = require("./ilead-feedback-stage-settings");
function parseILeadFeedbackSettingsEvents(data) {
    if (data.lead_created !== null && typeof data.lead_created === 'object')
        data.lead_created = (0, ilead_feedback_stage_settings_1.parseILeadFeedbackStageSettings)(data.lead_created);
    if (data.disqualified_lead !== null && typeof data.disqualified_lead === 'object')
        data.disqualified_lead = (0, ilead_feedback_stage_settings_1.parseILeadFeedbackStageSettings)(data.disqualified_lead);
    if (data.schedule !== null && typeof data.schedule === 'object')
        data.schedule = (0, ilead_feedback_stage_settings_1.parseILeadFeedbackStageSettings)(data.schedule);
    if (data.no_show !== null && typeof data.no_show === 'object')
        data.no_show = (0, ilead_feedback_stage_settings_1.parseILeadFeedbackStageSettings)(data.no_show);
    if (data.quote !== null && typeof data.quote === 'object')
        data.quote = (0, ilead_feedback_stage_settings_1.parseILeadFeedbackStageSettings)(data.quote);
    if (data.purchase !== null && typeof data.purchase === 'object')
        data.purchase = (0, ilead_feedback_stage_settings_1.parseILeadFeedbackStageSettings)(data.purchase);
    if (data.lost_deal !== null && typeof data.lost_deal === 'object')
        data.lost_deal = (0, ilead_feedback_stage_settings_1.parseILeadFeedbackStageSettings)(data.lost_deal);
    return data;
}
exports.parseILeadFeedbackSettingsEvents = parseILeadFeedbackSettingsEvents;
